import React from 'react'
import { Link } from 'react-router-dom'

import {
  makeStyles,
  createStyles,
  Drawer,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Divider,
  Avatar,
  Button,
} from '@material-ui/core'

import HubLogo from 'assets/hub-logo.svg'
import AlaLogo from 'assets/launch-academy-logo.svg'
import NavSidebarItem from './NavSidebarItem'
import { routes, navItems } from 'constants/routes'
import { hubModes, useAppContext } from 'contexts/AppContext'
import CohortSelector from 'components/Internal/CohortSelector'
export const DRAWER_WIDTH = 288

const useStyles = makeStyles(theme =>
  createStyles({
    root: {
      width: DRAWER_WIDTH,
      overflowX: 'hidden',
    },
    grid: { height: '100%' },

    logoListItem: { ...theme.mixins.toolbar },

    listItemNoPadding: {
      paddingTop: 0,
      paddingBottom: 0,
    },

    profilePhoto: {
      width: 24,
      height: 24,
    },

    signOutGridItem: { textAlign: 'center' },
  })
)

interface INavSidebarProps {
  isMobile: boolean
  restrictions: string[]
  mobileOpen: boolean
  hubMode: hubModes | undefined
  onCloseDrawer: () => void
}

const NavSidebar: React.FunctionComponent<INavSidebarProps> = ({
  isMobile,
  restrictions,
  mobileOpen,
  onCloseDrawer,
  hubMode,
}) => {
  const classes = useStyles()

  const { userDocState, cohortDoc } = useAppContext()
  const user = userDocState.doc

  return (
    <Drawer
      variant={isMobile ? 'temporary' : 'permanent'}
      open={isMobile ? mobileOpen : true}
      onClose={onCloseDrawer}
      classes={{ root: classes.root, paper: classes.root }}
      ModalProps={{ keepMounted: true }}
    >
      <Grid
        container
        justify="space-between"
        direction="column"
        className={classes.grid}
        spacing={3}
        wrap="nowrap"
      >
        <Grid item component="nav" aria-label="main navigation">
          <ListItem
            button
            component={Link}
            to="/"
            classes={{ root: classes.logoListItem }}
          >
            <ListItemAvatar>
              <></>
            </ListItemAvatar>
            {hubMode === hubModes.student ||
            hubMode === hubModes.studentViewOnly ? (
              <img
                src={AlaLogo}
                width={113}
                height={40}
                alt="Antler Launch Academy"
              />
            ) : (
              <img src={HubLogo} width={89} height={35} alt="Antler Hub" />
            )}
          </ListItem>

          <Divider />

          <List>
            {hubMode !== undefined &&
              Array.isArray(navItems[hubMode]) &&
              navItems[hubMode].map(item => {
                if (
                  restrictions?.includes('development') &&
                  item.restrictions?.includes('development')
                )
                  return null

                return (
                  <NavSidebarItem
                    key={item.route}
                    item={item}
                    restrictions={restrictions}
                  />
                )
              })}
          </List>
        </Grid>

        {/* Spacer */}
        <Grid item xs />

        <Grid item>
          {hubMode !== hubModes.internal && (
            <ListItem alignItems="flex-start">
              <ListItemAvatar>
                <Avatar
                  src={user?.profilePhoto?.[0]?.downloadURL}
                  className={classes.profilePhoto}
                />
              </ListItemAvatar>

              <ListItemText
                primary={
                  user &&
                  `${user?.preferredName || user?.firstName} ${user?.lastName}`
                }
                primaryTypographyProps={{
                  variant: 'subtitle2',
                  color: 'textSecondary',
                }}
                secondary={
                  cohortDoc && `${cohortDoc?.location} (${cohortDoc?.cohort})`
                }
                secondaryTypographyProps={{ variant: 'body2' }}
              />
            </ListItem>
          )}

          {/* <Grid container wrap="nowrap" spacing={1}>
            <Grid item>
              <Avatar
                src={user?.profilePhoto?.[0]?.downloadURL}
                className={classes.profilePhoto}
              />
            </Grid>

            <Grid item xs>
              <Typography variant="overline">
                {user?.preferredName ?? user?.firstName} {user?.lastName}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {user?.cohort}
              </Typography>
            </Grid>
          </Grid> */}
          {/* </Grid>
          
        <Grid item className={classes.signOutGridItem}> */}

          {hubMode === hubModes.internal && (
            <>
              <ListItem alignItems="flex-start">
                <ListItemAvatar>
                  <Avatar
                    src={user?.profilePhoto?.[0]?.downloadURL}
                    className={classes.profilePhoto}
                  />
                </ListItemAvatar>

                <ListItemText
                  primary={
                    user &&
                    `${user?.preferredName || user?.firstName} ${
                      user?.lastName
                    }`
                  }
                  primaryTypographyProps={{
                    variant: 'subtitle2',
                    color: 'textSecondary',
                  }}
                  secondary="ANTLER"
                  secondaryTypographyProps={{ variant: 'body2' }}
                />
              </ListItem>
              <ListItem>
                <ListItemAvatar>
                  <div />
                </ListItemAvatar>
                <CohortSelector />
              </ListItem>
            </>
          )}
          <ListItem>
            <ListItemAvatar>
              <span />
            </ListItemAvatar>

            <Button
              variant="outlined"
              color="primary"
              component={Link}
              to={routes.signOut}
            >
              Sign Out
            </Button>
          </ListItem>
        </Grid>
      </Grid>
    </Drawer>
  )
}

export default NavSidebar
